import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Grid,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import SecurityIcon from '@mui/icons-material/Security';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { useUser } from '../../contexts/UserContext';

export default function Profile() {
  const { user } = useUser();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Profile
      </Typography>
      
      <Grid container spacing={3}>
        {/* User Info Card */}
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3, textAlign: 'center' }}>
            <Avatar
              sx={{ width: 100, height: 100, mx: 'auto', mb: 2 }}
              src={user?.avatar}
            >
              <PersonIcon />
            </Avatar>
            <Typography variant="h6">{user?.name}</Typography>
            <Typography color="textSecondary" gutterBottom>
              {user?.email}
            </Typography>
            <Button variant="contained" color="primary" sx={{ mt: 2 }}>
              Edit Profile
            </Button>
          </Paper>
        </Grid>

        {/* Account Details */}
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 3 }}>
            <List>
              <ListItem>
                <ListItemIcon>
                  <PersonIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Account Information"
                  secondary="Manage your account details and preferences"
                />
                <Button variant="outlined" size="small">
                  Manage
                </Button>
              </ListItem>
              <Divider />
              
              <ListItem>
                <ListItemIcon>
                  <SecurityIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Security Settings"
                  secondary="Update your password and security preferences"
                />
                <Button variant="outlined" size="small">
                  Update
                </Button>
              </ListItem>
              <Divider />
              
              <ListItem>
                <ListItemIcon>
                  <NotificationsIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Notification Preferences"
                  secondary="Customize your notification settings"
                />
                <Button variant="outlined" size="small">
                  Configure
                </Button>
              </ListItem>
              <Divider />
              
              <ListItem>
                <ListItemIcon>
                  <AccountBalanceWalletIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Balance & Transactions"
                  secondary="View your balance and transaction history"
                />
                <Button variant="outlined" size="small">
                  View
                </Button>
              </ListItem>
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
} 